import { MACLicensesPage } from './LicensesPage';
import MACLicensesPreselectedPage from './LicensesPreselectedPage';
import { MACOrdersPage } from './OrdersPage';
import { MACOrdersPreselectedPage } from './OrdersPreselectedPage';
import { MACConfigUserPage } from './ConfigUserPage';
import { MACEditDetailsPage } from './EditDetailsPage';
import { MACLicenseEvaluationPage } from './LicenseEvaluationPage';
import MACPaymentDetailsPage from './PaymentDetailsPage';
import MACPaymentPage from './PaymentPage';
import MACUpdateCreditCardPage from './UpdateCreditCardPage';
import MACEnableAutoRenewPage from './EnableAutoRenewPage';
import { MACInvoicesPage } from './InvoicesPage';
import { MACInvoicesPreselectedPage } from './InvoicesPreselectedPage';
import { UpdateServerIdPage } from './UpdateServerIdPage';
import { PartnersPage } from './PartnersPage';
import { MACAddonLicenseViewPage } from './AddonLicenseViewPage';
import { MACAddonLicenseEvaluationPage } from './AddonLicenseEvaluationPage';
import { DownloadSourcePage } from './DownloadSourcePage';
import { EmailRedirectPage } from './EmailRedirectPage';

import macReducer from './duck/reducer';

export * from './duck/actions';
export {
  MACLicensesPage,
  MACLicensesPreselectedPage,
  MACOrdersPage,
  MACOrdersPreselectedPage,
  MACConfigUserPage,
  MACEditDetailsPage,
  MACLicenseEvaluationPage,
  MACPaymentDetailsPage,
  MACPaymentPage,
  MACUpdateCreditCardPage,
  MACInvoicesPage,
  MACInvoicesPreselectedPage,
  UpdateServerIdPage,
  PartnersPage,
  MACAddonLicenseViewPage,
  MACAddonLicenseEvaluationPage,
  MACEnableAutoRenewPage,
  DownloadSourcePage,
  EmailRedirectPage,
};

export default macReducer;
